import { styled } from "styled-components"

const Contact = () => {
  return(
    <Container>
      <ContactButton>CONTACT</ContactButton>
    </Container>
  )
}

export default Contact


const Container = styled.section`
  height:382px;
  background-color: #060C17;
  display: flex;
  justify-content: center;
  align-items: center;
`


const ContactButton = styled.button`
  font-family: 'Pretendard';
  font-weight: 400;
  font-size: 21px;
  line-height: 125%;
  padding: 16px 54px;
  background-color: #101A2F;
  color:#1B76FF;
  border:none;
  border-radius: 6px;
  :hover{
    color:#fff;
    background:#fff;
    border:1px solid #276BFF;
  }
`